import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

import 'react-toastify/dist/ReactToastify.css';

const Head = () => {
    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.general
    );
    const { REACT_APP_HOTJAR_ID } = process.env;
    const renderHotJar = () => {
        return (
            <script type='text/javascript'>
                {`
                        <!-- Hotjar Tracking Code -->
                        (function(h, o, t, j, a, r) { h.hj = h.hj || function() {
                            (h.hj.q = h.hj.q || []).push(arguments)
                        };
                            h._hjSettings = { hjid: ${REACT_APP_HOTJAR_ID}, hjsv: 6 };
                            a = o.getElementsByTagName('head')[0];
                            r = o.createElement('script');
                            r.async = 1;
                            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                            a.appendChild(r);
                        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
                    `}
            </script>
        );
    };

    return <Helmet title={localization.title}>{renderHotJar()}</Helmet>;
};

export default Head;
